import React, { useEffect, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
} from "reactstrap";

import './menubar.css'
import { MenuBarItem, NavbarLogo, ProfileIconAndLogin } from "./MenuBarComponent";
import { useLocation, useNavigate } from 'react-router';
import { clearGlobalVariables } from "../Components/ConfigHelperFunction";
import ScrollToTop from "react-scroll-to-top";

const MenuBar2 = props => {

  const [isOpen, setIsOpen] = useState(false);
  const [headerstyle, SetHeaderStyle] = useState(global.$header.style);
  const navigate = useNavigate();
  const location = useLocation()

  const toggle = () => setIsOpen(!isOpen);
  const menuItems = global.$menuItems.split(',');

  useEffect(() => {

    if (location.pathname === '/home' || location.pathname === '/') {
      navigate('/home');
    }

    if (location.pathname === '/Logout') {
      props.setLogin(false);
      global.$loginstatus = "false";
      navigate('/LoginForm');
      clearGlobalVariables();
    }
  }, [location.pathname]);


  return (
    <>
      <div className="topbar">
        <Navbar
          expand="md"
          style={headerstyle}
          className="menubar2"
        >
          {/* LEFT SIDE LOGO */}
          <NavbarLogo />

          {/* NAVLINK ITEMS */}
          <NavbarToggler onClick={toggle} />
          <Collapse isOpen={isOpen} navbar style={headerstyle} className="navbar-collapse-style">
            <Nav navbar>
              {

                menuItems.map((menuItem) => {
                  if (global.$header.menu[menuItem]) {
                    return (
                      <MenuBarItem
                        menuItem={menuItem}
                        menuItemObject={global.$header.menu[menuItem]}
                        login={props.login}
                        key={menuItem}
                      />)
                  }
                })
              }

              {/* LOGIN BUTTON AND USER PROFILE ICON */}
              <ProfileIconAndLogin />

            </Nav>
          </Collapse>
        </Navbar>
      </div>
      <ScrollToTop
        color={global.$scrolltotop.color}
        style={global.$scrolltotop.styles}
      />
    </>
  );
};

export default MenuBar2;
